import { render, staticRenderFns } from "./textAndImg2.vue?vue&type=template&id=1faec5e4&scoped=true&"
import script from "./textAndImg2.vue?vue&type=script&lang=js&"
export * from "./textAndImg2.vue?vue&type=script&lang=js&"
import style0 from "./textAndImg2.vue?vue&type=style&index=0&id=1faec5e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faec5e4",
  null
  
)

export default component.exports